<div
  class="input-field"
  [class.input-field--no-padding]="setNoPadding()"
  [class.input-field--error]="isInvalidShown()"
  [class.input-field--size-small]="size() === 'small'"
  [class.input-field--disabled]="disabled()"
  (pointerdown)="onWrapperInteraction()"
  (keydown)="onWrapperInteraction()"
>
  @if (label()) {
    <label [for]="id()" class="input-field__label" (pointerdown)="engage()">
      <!-- Before the text: a float after it would drop to the next line. -->
      @if (hint(); as hint) {
        <span class="typography-small-text tw:float-right tw:ml-3 tw:text-gray-3">{{ hint }}</span>
      }
      {{ label() }}
      @if (required()) {
        <span class="input-field__label-required">*</span>
      }
    </label>
  }

  <div class="input-field__main">
    @if (prefixText()) {
      <span class="input-field__field-prefix-text">{{ prefixText() }}</span>
    }
    <div class="empty-hidden input-field__main-left-icon">
      @if (prefixIcon(); as icon) {
        <fr8bot-ui-icon [name]="icon" [size]="16" />
      } @else {
        <ng-content select="[prefix]" />
      }
    </div>

    <input
      #inputElement
      [id]="id()"
      [attr.name]="inputName()"
      [attr.autocomplete]="autocomplete()"
      [type]="inputType()"
      [value]="displayValue()"
      [placeholder]="placeholder()"
      [readonly]="isReadonly()"
      [disabled]="disabled()"
      [uiInputFocus]="isFocused()"
      (input)="onInput(inputElement)"
      (pointerdown)="engage()"
      (focus)="onFocus()"
      (blur)="onBlur()"
      class="input-field__main-input"
    />

    <div class="input-field__main-custom-value-template empty-hidden">
      <ng-content select="[custom-value-template]" />
    </div>

    <div class="empty-hidden input-field__main-right-icon">
      @if (postfixIcon(); as icon) {
        <fr8bot-ui-icon [name]="icon" [size]="16" />
      } @else {
        <ng-content select="[postfix]" />
      }
    </div>
    @if (postfixText()) {
      <span class="input-field__field-postfix-text">{{ postfixText() }}</span>
    }
  </div>
  @if (isErrorVisible()) {
    <div class="empty-hidden">
      @if (!errorRef()) {
        <fr8bot-ui-validation-error [error]="error()" />
      } @else {
        <ng-content />
      }
    </div>
  }
</div>
